import { render, staticRenderFns } from "./UserNotificationsList.vue?vue&type=template&id=cd174b5a&scoped=true&functional=true&"
import script from "./UserNotificationsList.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsList.vue?vue&type=style&index=0&id=cd174b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "cd174b5a",
  null
  
)

export default component.exports